export { default } from './NewPageDatatable';
